import axios from "api/axios"
import { APIResponse, Config, ConfigWithURLParams } from "api/types"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"

import {
  Country,
  Currency,
  Curriculum,
  Language,
  QualificationField,
  State,
  Subject,
} from "./types"
import { urls } from "./urls"

export default {
  subjects: {
    list: async ({ params }: Config): Promise<APIResponse<Subject[]>> => {
      try {
        const res = await axios.get(urls.subjects.list(), { params })
        return formatSuccessResponse(res)
      } catch (e) {
        throw formatErrorResponse(e)
      }
    },
  },

  curricula: {
    list: async ({ params }: Config): Promise<APIResponse<Curriculum[]>> => {
      try {
        const res = await axios.get(urls.curricula.list(), { params })
        return formatSuccessResponse(res)
      } catch (e) {
        throw formatErrorResponse(e)
      }
    },
  },

  languages: {
    list: async ({ params }: Config): Promise<APIResponse<Language[]>> => {
      try {
        const res = await axios.get(urls.languages.list(), { params })
        return formatSuccessResponse(res)
      } catch (e) {
        throw formatErrorResponse(e)
      }
    },
  },

  countries: {
    list: async ({ params }: Config): Promise<APIResponse<Country[]>> => {
      try {
        const res = await axios.get(urls.countries.list(), {
          params,
        })
        return formatSuccessResponse(res)
      } catch (e) {
        throw formatErrorResponse(e)
      }
    },
  },
  states: {
    list: async ({
      urlParams,
      params,
    }: ConfigWithURLParams): Promise<APIResponse<State[]>> => {
      try {
        const res = await axios.get(urls.states.list(urlParams.country), {
          params,
        })
        return formatSuccessResponse(res)
      } catch (e) {
        throw formatErrorResponse(e)
      }
    },
  },
  qualificationFields: {
    // This is bulk-create
    create: async ({
      data,
    }: Config): Promise<APIResponse<QualificationField[]>> => {
      try {
        const res = await axios.post(urls.qualificationFields.create(), data)
        return formatSuccessResponse(res)
      } catch (e) {
        throw formatErrorResponse(e)
      }
    },

    list: async ({
      params: { page = -1 },
    }: Config): Promise<APIResponse<QualificationField[]>> => {
      try {
        const res = await axios.get(urls.qualificationFields.list(), {
          params: { page },
        })
        return formatSuccessResponse(res)
      } catch (e) {
        throw formatErrorResponse(e)
      }
    },
  },
  currency: {
    listCurrencies: async ({
      params,
    }: Config): Promise<APIResponse<Currency[]>> => {
      try {
        const res = await axios.get(urls.currencies.list(), {
          params,
        })
        return formatSuccessResponse(res)
      } catch (e) {
        throw formatErrorResponse(e)
      }
    },
  },
}
